import { render, staticRenderFns } from "./WarningCitizenIdIcon.vue?vue&type=template&id=0cec99ea&scoped=true"
import script from "./WarningCitizenIdIcon.vue?vue&type=script&lang=js"
export * from "./WarningCitizenIdIcon.vue?vue&type=script&lang=js"
import style0 from "./WarningCitizenIdIcon.vue?vue&type=style&index=0&id=0cec99ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec99ea",
  null
  
)

export default component.exports